







































































































import SimpleMap from '../../core/components/SimpleMap.vue';
import Input from '../../core/components/Input.vue';
import SectionTitle from '../../core/components/SectionTitle.vue';
import InfoIcon from '../../core/components/InfoIcon.vue';
import DeleteConfirmation from './Geofences/DeleteConfirmation.vue';
import $ from 'jquery';
import {
    convertDictionaryToList,
    getIndexFromList,
    isNullOrEmpty
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import {
    MsgBox,
    Button,
    Combobox,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';
import { CompaniesService } from '../../settings/api/CompaniesService';
import { CompanyStopConfig, defaultStopsValues, defaultStopTimeValue, SavedStopSetting, stopConfiguration, StopTypes, tooltipStopSpeed, tooltipStopTime } from '../../settings/models/Companies';
import { Company } from '../../core/models';

@Component({
    components: {
        Loading,
        SimpleMap,
        Combobox,
        Button,
        Input,
        SectionTitle,
        DeleteConfirmation,
        InfoIcon
    }
})
export default class TravelSettings extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({default: false}) visible: boolean;
    stopTypeSelected: object | null = null;
    stopTypeRV: boolean = false;
    loadingSetting: boolean = false;
    needToResetConfig: boolean = false;
    stopValue: number | string = '';
    stopsTypes:Array<{
        id: number; //type
        value: string; //text
    }> = [];
    pendingStopTypes: boolean = false;
    errorMsg: string = '';
    maxLengthStopValue: number = 3;
    //delete confirmation
    confirmationDelete: boolean = false;
    loadingIgnoredPeriods: boolean = false;
    deleteModalTitle: string = '';
    deleteBody: string = '';

    showDeleteConfirmationDialog(title, msgBody) {
        this.deleteModalTitle = title;
        this.deleteBody = msgBody;
        this.confirmationDelete = true;
    }

    setErrorForm(text) {
        this.errorMsg = text;
    }

    clickResetSetting(){
        let defaultConfigMessage = `La configuración por defecto es parada <b>${stopConfiguration[StopTypes.time]}</b> de <b>${defaultStopTimeValue}</b> minutos<br><br>¿Está seguro que desea cargar ésta configuración?`;
        this.showDeleteConfirmationDialog(
            'Reestablecer configuración de Paradas', 
            defaultConfigMessage
        );
    }

    deleteAction(value) {
        if (value) {
            this.confirmationDelete = false;
            this.needToResetConfig = true;
            this.stopValue = defaultStopTimeValue;
            this.saveSetting();
            
        } else {
            this.needToResetConfig = false
            this.confirmationDelete = false;
        }
    }


    updateStopValue(value){
        this.stopValue = value;
    }

    get getTooltipForValue(){
         if(this.stopTypeSelected !== null && this.stopTypeSelected['id'] == StopTypes.time){
            return tooltipStopTime
         }
         return tooltipStopSpeed
    }

    get getLabelStopValue(){
        if(this.stopTypeSelected !== null && this.stopTypeSelected['id'] == StopTypes.time){
            return '¿Cuántos minutos?'
        }
        return '¿Cuántos km/h?'
    }

    get getPlaceholderStopValue(){
        if(this.stopTypeSelected !== null && this.stopTypeSelected['id'] == StopTypes.speed){
            return 'Ejemplo: 3'
        }
        return 'Ejemplo: ' + defaultStopTimeValue
    }

    pendingRequest(value){
        this.loadingSetting = value;
    }
   
    showLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    showSuccessLoadingDialog(response, alternative_msg){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg
        });
        this.closeModal();
    }
    showCatchLoadingDialog(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    saveSetting() {
        this.pendingRequest(true);
        this.showLoadingDialog('Guardando Configuración...');
        let configToSubmit = this.getData;
        CompaniesService.setStopSettingForCompany(configToSubmit)
            .then(res => {
                this.refreshMap();
                this.showSuccessLoadingDialog(res, 'Configuracion de paradas actualizada con exito');
                this.updateConfigInCompaniesStore(configToSubmit);
                this.pendingRequest(false);
            })
            .catch(err => {
                this.showCatchLoadingDialog(err, 'No se pudo guardar la configuración');
                this.pendingRequest(false);
            });
    }

    updateConfigInCompaniesStore(newConfig:CompanyStopConfig){
        this.$_setStopConfigForCompany({
            company_id: this.getCurrentCompanyId(),
            newConfig: {
                type: newConfig.stop_type,
                value: newConfig.stop_value
            }
        })
    }

    get getData():CompanyStopConfig {
        return {
            company_id: this.getCurrentCompanyId(),
            reset_configurations: this.needToResetConfig,
            stop_type: this.stopTypeSelected ? Number(this.stopTypeSelected['id']) : -1,
            stop_value: Number(this.stopValue)
        }
    }

    updateStopTypeSelectedByUser(value) {
        let defaultStopValue:number | string = defaultStopsValues[StopTypes.time];
        if(value && value.id == StopTypes.speed){
            //si el tipo es por tiempo, no hay un valor default establecido
            defaultStopValue = defaultStopsValues[StopTypes.speed];
        }
        this.stopValue = defaultStopValue
        this.stopTypeSelected = value;
    }
    updateStopTypeRV(value) {
        this.stopTypeRV = value;
    }

    get formIsValid() {
        this.setErrorForm('');
        if (this.stopTypeSelected == null) {
            this.setErrorForm('No seleccionó el Tipo de Parada');
            return false;
        }

        if (isNullOrEmpty(this.stopValue)) {
            this.setErrorForm('No ingresó el valor');
            return false;
        }

        if (this.stopValue.toString().length > this.maxLengthStopValue ) {
            this.setErrorForm(`El valor es muy largo. Máximo ${this.maxLengthStopValue} caracteres`);
            return false;
        }

        return true;
    }

    @Emit()
    closeModal() {}

    mounted() {
        this.$nextTick(() => {
            this.getStopTypes();
        });
    }

    getCurrentCompanyId(){
        return this.$_getSelectedCompanyById as number
    }

    getCurrentCompanyIndex(){
        return this.$_getCompanies.findIndex(item => Number(item['id']) == this.getCurrentCompanyId())
    }

    setSavedSettingForSelectedCompany(){
        //obtengo la configuracion de la empresa actual de la lista de companias en el indice que corresponde
        let currentCompanyConfig = this.$store.state.companies[this.getCurrentCompanyId()].stops_configuration;
        this.setStopTypeById(currentCompanyConfig.type); //cargo el tipo de parada
        this.stopValue = currentCompanyConfig.value; //cargo el valor de la parada
    }

    setStopTypeById(typeId: number){
        let indexStopType = getIndexFromList(this.stopsTypes, 'id', typeId);
        if(indexStopType !== -1){
            this.stopTypeSelected = this.stopsTypes[indexStopType]
        }
    }

    getStopTypes(){
        //obtener los tipos de paradas
        this.pendingStopTypes = true;
        CompaniesService.getCompaniesConfigurations()
            .then((res) => {
                this.stopsTypes = convertDictionaryToList(res.stop_configuration);
                this.setSavedSettingForSelectedCompany();
                this.pendingStopTypes = false;
            }).catch((err) => {
               this.showCatchLoadingDialog(err, 'No se pudieron obtener los tipos de paradas'); 
               this.pendingStopTypes = false;
            })
    }

    @Emit()
    refreshMap(){}
}
